import React from 'react';
import { spacing, typography } from './tokens';
import AdminCard from './AdminCard';

/**
 * AdminSection
 * 
 * Standardized section component for admin pages.
 * Wraps content in a card with optional title.
 * 
 * @param {string} title - Optional section title
 * @param {ReactNode} children - Section content
 * @param {ReactNode} actions - Optional actions in header
 */
export default function AdminSection({ title, children, actions }) {
  return (
    <AdminCard title={title} actions={actions}>
      {children}
    </AdminCard>
  );
}

